module.exports = __webpack_public_path__ + "static/media/toon2.54059b12.png";